import React, { useState, useEffect } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import './main.css';

const PongalSankrantiBanner = ({ onClose }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        // Check if sticker was previously dismissed
        const dismissed = localStorage.getItem('pongal_sticker_2026_dismissed');
        if (dismissed === 'true') {
            setIsVisible(false);
        }
    }, []);

    const handleClose = (e) => {
        e.stopPropagation();
        setIsVisible(false);
        localStorage.setItem('pongal_sticker_2026_dismissed', 'true');
        if (onClose) onClose();
    };

    if (!isVisible) return null;

    return (
        <div
            className={`pongal-floating-sticker ${isHovered ? 'hovered' : ''}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {/* Close button - shows on hover */}
            <button className="pongal-sticker-close" onClick={handleClose}>
                <CloseOutlined />
            </button>

            {/* Sticker Image */}
            <img
                src={"https://public-bucket-v3.s3.ap-south-1.amazonaws.com/pongal-idm.gif"}
                alt="Happy Pongal & Sankranti"
                className="pongal-sticker-image"
            />

            {/* Greeting tooltip */}
            <div className="pongal-greeting-tooltip">
                <span className="greeting-text">Happy Pongal / Sankranti! 🌾</span>
            </div>
        </div>
    );
};

export default PongalSankrantiBanner;
